'use client';

import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Navbar } from '../components/layout/navbar';
import { Footer } from '../components/layout/footer';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '../components/ui/tabs';
import { Button } from '../components/ui/button';
import { useAuthStore } from '../stores';
import { Bookmark, History, Construction } from 'lucide-react';

export default function LibraryPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();

  const [activeTab, setActiveTab] = useState('saved');

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/signin');
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="flex min-h-screen flex-col bg-black text-white">
      {/* Gradient Background */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-violet-600/20 blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-cyan-600/20 blur-[120px]" />
      </div>

      <Navbar />
      <main className="flex-1 container px-4 py-8 md:px-6 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-bold">Your Library</h1>
          </div>

          <Tabs
            value={activeTab}
            onValueChange={setActiveTab}
            className="w-full"
          >
            <TabsList className="mb-6 grid w-full grid-cols-2 md:w-auto md:inline-flex">
              <TabsTrigger value="saved" className="flex items-center gap-2">
                <Bookmark className="h-4 w-4" />
                <span>Saved</span>
              </TabsTrigger>
              <TabsTrigger value="history" className="flex items-center gap-2">
                <History className="h-4 w-4" />
                <span>Reading History</span>
              </TabsTrigger>
            </TabsList>

            <TabsContent value="saved">
              <div className="text-center py-16 border rounded-lg bg-zinc-900/30 border-white/10">
                <Construction className="h-16 w-16 mx-auto text-purple-500 mb-4" />
                <h3 className="text-2xl font-bold mb-2 text-white">
                  Coming Soon
                </h3>
                <p className="text-zinc-400 mb-6 max-w-md mx-auto">
                  Save your favorite articles to read later. This feature is
                  currently under development.
                </p>
                <Link to="/blog">
                  <Button className="bg-purple-600 hover:bg-purple-700 text-white">
                    Browse Articles
                  </Button>
                </Link>
              </div>
            </TabsContent>

            <TabsContent value="history">
              <div className="text-center py-16 border rounded-lg bg-zinc-900/30 border-white/10">
                <Construction className="h-16 w-16 mx-auto text-purple-500 mb-4" />
                <h3 className="text-2xl font-bold mb-2 text-white">
                  Coming Soon
                </h3>
                <p className="text-zinc-400 mb-6 max-w-md mx-auto">
                  Your reading history will be tracked here. This feature is
                  currently under development.
                </p>
                <Link to="/blog" className="inline-block">
                  <Button className="bg-purple-600 hover:bg-purple-700 text-white min-h-[48px] px-6">
                    Start Reading
                  </Button>
                </Link>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </main>
      <Footer />
    </div>
  );
}
